import { createAction, createReducer } from '@reduxjs/toolkit';
import { IAction, ILimite } from './interface/apiInterfaces';
import { IInitialState, ILimit } from './interface/reduxInterfaces';

const INITIAL_STATE: IInitialState = {
  isActive: false,
  isLoading: false,
  gotSuccess: false,
  gotError: false,
  dateSearch: {
    start: '',
    end: '',
  },
  limits: [],
};

export const getLimitListFromApi = createAction(
  '@limitApp/GET_LIMIT_LIST_FROM_API'
);
export const gotLimitListFromApi = createAction<any>(
  '@limitApp/GOT_LIMIT_LIST_FROM_API'
);
export const gotErrorFromlimitListFromApi = createAction(
  '@limitApp/GOT_ERROR_LIMIT_LIST_FROM_API'
);
export const eraserLimitList = createAction('@limitApp/ERASER_LIMIT_LIST');
export const logoutLimitApp = createAction('@limitApp/LOGOUT_LIMIT_APP');

const limitAppReducer = createReducer(INITIAL_STATE, {
  [getLimitListFromApi.type]: (state) => ({
    ...state,
    isActive: false,
    isLoading: true,
    gotSuccess: false,
    gotError: false,
  }),
  [gotLimitListFromApi.type]: (state, action: IAction) => ({
    ...state,
    isActive: true,
    gotError: false,
    gotSuccess: true,
    isLoading: false,
    dateSearch: {
      start: action.payload.data_de_pesquisa.de,
      end: action.payload.data_de_pesquisa.ate,
    },
    limits: action.payload.limites.map((cliente: ILimite) => {
      const data: ILimit = {
        account: cliente.conta,
        accountFormat: cliente.formato_conta,
        agency: cliente.agencia,
        cel: cliente.celular,
        cnpjCpf: cliente.cpf_cnpj,
        companyName: cliente.nome_razaoSocial,
        digit: cliente.digito,
        email: cliente.email,
        type: cliente.tipo_limite,
        id: cliente.id,
        partner: cliente.parceiro,
        referenceDate: cliente.data_referencia,
        value: cliente.valor,
      };
      return data;
    }),
  }),
  [gotErrorFromlimitListFromApi.type]: (state) => ({
    ...state,
    gotError: true,
    gotSuccess: false,
    isLoading: false,
  }),
  [eraserLimitList.type]: (state) => ({
    ...state,
    gotError: false,
    gotSuccess: false,
    isLoading: false,
    debits: [],
  }),
  [logoutLimitApp.type]: (state) => ({
    ...state,
    isActive: false,
    isLoading: false,
    gotSuccess: false,
    gotError: false,
    dateSearch: {
      start: '',
      end: '',
    },
    debits: [],
  }),
});

export default limitAppReducer;
